import { PROJECT_INFO_TEMPLATE, TEAM_TEMPLATE } from 'shared/quill/editorOptions'

export const formatProjectInfo = (info: string): string => {
  // Find correct solution for this
  // eslint-disable-next-line no-prototype-builtins
  if (info.includes('{"notes":') && JSON.parse(info).hasOwnProperty('notes')) {
    return JSON.parse(info).notes
  }

  return info.replace(/\\n/g, '')
}

export const setInitialData = (isCampaign: boolean, initialData: string | undefined) => {
  const template = isCampaign ? PROJECT_INFO_TEMPLATE : TEAM_TEMPLATE

  return initialData ? formatProjectInfo(initialData) : template
}
